import { Row, Col } from 'antd';

import { IEmployee } from '../../common/model/employee.model';

import { EmployeeComponent } from '../officeDetail';

type Props = {
  employees: IEmployee[];
};

const TeamSection: React.FC<Props> = ({ employees }) => {
  return (
    <Row gutter={[32, 32]} justify="space-around">
      {employees.map((employee) => (
        <Col key={employee.name} xs={24} sm={12} lg={8} xl={6}>
          <EmployeeComponent employee={employee} />
        </Col>
      ))}
    </Row>
  );
};

export default TeamSection;
